import { useCallback, useRef, useState } from "react";
import styles from "../list.module.css";
import dayjs from "dayjs";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Typography, Checkbox } from "@mui/material";
import { Calendar, Map, Search, X } from "react-feather";
import { Close, PersonAddAltOutlined } from "@mui/icons-material";
import { DateRangePicker } from "rsuite";
import { useReactToPrint } from "react-to-print";
import TablePaginationComponent from "../../../../components/TablePagination";
import { StyledMainTableCell, StyledMainTableRow } from "../../../../components/TableComponent";
import { authData } from "../../../../components/GetAuth";
import { ComponentToPrintList } from "../ComponentToPrintList";

const ButtonArea = ({ data }) => {
    const componentRef = useRef();
    const Export = ({ onExport }) => (<Button onClick={(e) => onExport(e.target.value)} className="TableAddBU" style={{ width: "auto" }}>Export To CSV</Button>);

    const convertArrayOfObjectsToCSV = (array) => {
        let result = "";

        const columnDelimiter = ",";
        const lineDelimiter = "\n";
        const keys = ["booking_id", "post_code", "customer_name", "pickup_address", "order_status", "contact_no", "pickup_date"];

        keys.forEach((key) => {
            if (key === "booking_id") {
                result += "Booking Id";
            } else if (key === "post_code") {
                result += "Post Code";
            } else if (key === "customer_name") {
                result += "Customer Name";
            } else if (key === "pickup_address") {
                result += "Pickup _Address";
            } else if (key === "order_status") {
                result += "Order Status";
            } else if (key === "contact_no") {
                result += "Contact No";
            } else if (key === "pickup_date") {
                result += "Pickup Date";
            } else {
                result += key;
            }
            result += columnDelimiter;
        });
        result += lineDelimiter;

        array.forEach((item) => {
            let ctr = 0;
            keys.forEach((key) => {
                if (ctr > 0) result += columnDelimiter;
                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    };

    const downloadCSV = useCallback(() => {
        let newArray = data.map((row) => {
            return {
                booking_id: row?.booking_id,
                post_code: row?.post_code,
                customer_name: row?.customer_name,
                pickup_address: row?.pickup_details?.address.replace(/,/g, ""),
                order_status: row?.order_status === 1 || row?.payment_status === "1" ? "Paid" : "Unpaid",
                contact_no: row?.pickup_details?.phone,
                pickup_date: dayjs(row.pickup_date).format("DD/MM/YYYY"),
            };
        });

        const link = document.createElement("a");
        let csv = convertArrayOfObjectsToCSV(newArray);
        if (csv == null) return;

        const filename = "driver-list.csv";

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", filename);
        link.click();
    }, [data]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (<>
        <Export onExport={() => downloadCSV()} />
        <Button onClick={handlePrint} className="TableAddBU" style={{ width: "auto" }}>Print Bookings</Button>
        <div style={{ display: "none" }}>
            <ComponentToPrintList ref={componentRef} data={data} />
        </div>
    </>
    );
}

const Step1 = ({ selected, driverList, selectedDriverList, filteredData, filterVars, setFilterVars, setFormOpen, setSelectedDriverList, getOptimizeRoute, selectRowEvent, setSelected, page, setPage, rowsPerPage, setRowsPerPage, totalCount }) => {
    const auth = authData();


    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    return (<>
        {selectedDriverList?.length > 0 && <div>
            <p className={`${styles.DriverTitle}`}>Selected Driver</p>
            <div className={`${styles.DriverCardSec}`}>
                {driverList?.map(item => {
                    return (selectedDriverList?.indexOf(item?.id) > -1) ? <div className={`${styles.DriverCard}`}>
                        <div className={`${styles.DriverCardUnder}`}>
                            <div className={`${styles.DriverCardHead}`}>
                                <p>{item?.name}</p>
                                <button onClick={(e) => {
                                    setSelectedDriverList((prev) => {
                                        return prev?.filter((i) => i !== item?.id);
                                    });
                                }}>
                                    <X />
                                </button>
                            </div>
                            <p className={`${styles.DriverCardAddress}`}>{item?.address}</p>
                        </div>
                    </div> : null;
                })}
            </div>
        </div>}
        <div className="TableFilterHead">
            <div className="DataTableSearch WithFilter">
                <Search className="SearchIcon" />
                <TextField type="text" placeholder="Search" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
                {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec`}>
                        <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterVars?.date} showOneCalendar onChange={(e) => setFilterVars((prev) => { return { ...prev, date: e }; })} />
                    </div>
                </div>

                <div className={`${styles.FilterCard} Filter`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec`}>
                        <div className={`${styles.FilerButton}`}>
                            {(auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <Button className="TableAddBUName" disabled={selected.length === 0 || selectedDriverList?.length === 0} onClick={(e) => getOptimizeRoute()}><Map /> Route</Button>}
                            {(auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <Button className="TableAddBUName" onClick={(e) => setFormOpen(true)}><PersonAddAltOutlined /> Driver</Button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={`${styles.FilterCardButton} TableFilterBUSec`}>
            {selected.length > 0 ? (<Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">{selected.length} item selected</Typography>) : (<ButtonArea style={{ float: "right" }} data={filteredData}></ButtonArea>)}
        </div>
        <div className="CusTable">
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {(auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <StyledMainTableCell padding="checkbox">
                                <Checkbox
                                    className="AllCheckbox"
                                    color="primary"
                                    indeterminate={selected?.length > 0 && selected?.length < filteredData?.length}
                                    checked={filteredData?.length > 0 && selected?.length === filteredData?.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            const newSelected = filteredData.map((n) => n.id);
                                            setSelected(newSelected);
                                            return;
                                        }
                                        setSelected([]);
                                    }}
                                />
                            </StyledMainTableCell>}
                            <StyledMainTableCell>Booking Id</StyledMainTableCell>
                            <StyledMainTableCell>Post Code</StyledMainTableCell>
                            <StyledMainTableCell>Customer Name</StyledMainTableCell>
                            <StyledMainTableCell>Pickup Address</StyledMainTableCell>
                            <StyledMainTableCell>Order Status</StyledMainTableCell>
                            <StyledMainTableCell>Contact No</StyledMainTableCell>
                            <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filteredData.map((item) => {
                            const isItemSelected = selected.indexOf(item?.id) !== -1;

                            return (<StyledMainTableRow key={item?.id} sx={{ "&:last-child td, &:last-child th": { border: 0, cursor: "pointer" } }} onClick={(e) => selectRowEvent(item?.id)} aria-checked={isItemSelected} selected={isItemSelected}>
                                {(auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <TableCell padding="checkbox">
                                    <Checkbox color="primary" checked={isItemSelected} />
                                </TableCell>}
                                <TableCell component="th" scope="row">{item?.booking_id}</TableCell>
                                <TableCell component="th" scope="row">{item?.post_code}</TableCell>
                                <TableCell component="th" scope="row">{item?.customer_name}</TableCell>
                                <TableCell component="th" scope="row">{item?.pickup_details?.address}</TableCell>
                                <TableCell>{item?.payment_status === 1 || item?.payment_status === "1" ? (<Button className={`${styles.StatusBU} ${styles.DisaBU}`}>Paid</Button>) : (<Button className={`${styles.StatusBU}`}>Unpaid</Button>)}</TableCell>
                                <TableCell component="th" scope="row">{item?.pickup_details?.phone}</TableCell>
                                <TableCell component="th" scope="row">{dayjs(item?.pickup_date).format("DD/MM/YYYY")}</TableCell>
                            </StyledMainTableRow>);
                        })}

                        {filteredData.length === 0 && (<TableRow>
                            <TableCell colSpan={10} align="center">No data found</TableCell>
                        </TableRow>)}
                    </TableBody>

                    {filteredData?.length > 0 && (<TableFooter>
                        <TableRow>
                            <TablePaginationComponent
                                count={totalCount}
                                colSpan={6}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                handleChangePage={paginationChangePage}
                                handleChangeRowsPerPage={paginationChangeRowsPerPage}
                            />
                        </TableRow>
                    </TableFooter>)}
                </Table>
            </TableContainer>
        </div>
    </>);
};

export default Step1;